import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function Blog() {
  const blogPosts = [
    {
      id: 1,
      title: "Ndryshimet e Fundit në Legjislacionin Tatimor të Kosovës",
      excerpt: "Një përmbledhje e ndryshimeve më të rëndësishme në ligjet tatimore që ndikojnë në bizneset në Kosovë.",
      category: "Tatime",
      date: "15 Mars 2024",
      readTime: "5 min",
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400"
    },
    {
      id: 2,
      title: "Si të Optimizoni Kontabilitetin e Biznesit Tuaj",
      excerpt: "Këshilla praktike për përmirësimin e proceseve të kontabilitetit dhe rritjen e efikasitetit.",
      category: "Kontabilitet",
      date: "10 Mars 2024",
      readTime: "7 min",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400"
    },
    {
      id: 3,
      title: "Rëndësia e Auditimit të Brendshëm për Bizneset e Vogla",
      excerpt: "Pse auditimi i brendshëm është i rëndësishëm edhe për bizneset më të vogla dhe si ta implementoni.",
      category: "Auditim",
      date: "5 Mars 2024",
      readTime: "6 min",
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400"
    },
    {
      id: 4,
      title: "Strategji për Menaxhimin e Fluksit të Parave",
      excerpt: "Metoda të provuara për menaxhimin efektiv të fluksit të parave në biznesin tuaj.",
      category: "Financa",
      date: "1 Mars 2024",
      readTime: "8 min",
      image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400"
    },
    {
      id: 5,
      title: "Tendencat e Reja në Teknologjinë Kontabiliteti",
      excerpt: "Si teknologjia po ndryshon mënyrën se si bëjmë kontabilitetin dhe çfarë duhet të dini.",
      category: "Teknologji",
      date: "25 Shkurt 2024",
      readTime: "4 min",
      image: "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=400"
    },
    {
      id: 6,
      title: "Planifikimi Tatimor për Vitin e Ri",
      excerpt: "Hapat që duhet të ndiqni për planifikimin tatimor efektiv për vitin e ri.",
      category: "Tatime",
      date: "20 Shkurt 2024",
      readTime: "6 min",
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400"
    }
  ];

  const categories = ["Të Gjitha", "Tatime", "Kontabilitet", "Auditim", "Financa", "Teknologji"];

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>Blog</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="blog-intro">
            <h2>Lajme dhe Këshilla nga Ekspertët Tanë</h2>
            <p>Ndiqni artikujt tanë për të mësuar më shumë rreth kontabilitetit, tatimeve, financave dhe zhvillimit të biznesit.</p>
          </div>
          
          <div className="blog-categories">
            {categories.map((category, index) => (
              <button key={index} className="category-btn">
                {category}
              </button>
            ))}
          </div>
          
          <div className="blog-grid">
            {blogPosts.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-image">
                  <img src={post.image} alt={post.title} />
                  <div className="blog-category">{post.category}</div>
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-date">{post.date}</span>
                    <span className="blog-read-time">{post.readTime} lexim</span>
                  </div>
                  <h3 className="blog-title">{post.title}</h3>
                  <p className="blog-excerpt">{post.excerpt}</p>
                  <button className="read-more-btn">Lexo Më Shumë</button>
                </div>
              </article>
            ))}
          </div>
          
          <div className="blog-newsletter">
            <h2>Abonohuni në Newsletter</h2>
            <p>Merrni artikujt më të fundit dhe këshilla nga ekspertët tanë direkt në emailin tuaj.</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Emaili juaj" />
              <button className="subscribe-btn">Abonohu</button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blog; 